const SEARCH_HISTORY_KEY = 'patent_search_history';
const MAX_HISTORY_ITEMS = 50;

export const searchHistoryUtil = {
  addSearch: (searchData) => {
    try {
      const history = searchHistoryUtil.getHistory();
      const newEntry = {
        id: Date.now().toString(),
        timestamp: new Date().toISOString(),
        ...searchData,
      };
      
      const updatedHistory = [newEntry, ...history].slice(0, MAX_HISTORY_ITEMS);
      localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(updatedHistory));
      
      return newEntry;
    } catch (error) {
      console.error('Failed to save search history:', error);
      return null;
    }
  },

  getHistory: () => {
    try {
      const history = localStorage.getItem(SEARCH_HISTORY_KEY);
      return history ? JSON.parse(history) : [];
    } catch (error) {
      console.error('Failed to load search history:', error);
      return [];
    }
  },

  deleteSearch: (id) => {
    try {
      const history = searchHistoryUtil.getHistory();
      const updatedHistory = history.filter(item => item.id !== id);
      localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(updatedHistory));
      return true;
    } catch (error) {
      console.error('Failed to delete search history:', error);
      return false;
    }
  },

  clearAll: () => {
    try {
      localStorage.removeItem(SEARCH_HISTORY_KEY);
      return true;
    } catch (error) {
      console.error('Failed to clear search history:', error);
      return false;
    }
  },
};

